// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
//
// The page's own title, as React state (S3-02).
//
// `useSyncExternalStore` rather than a `useState` and a subscribing effect, which is the mistake
// M8-72 recorded in full: React runs a child's effects before its parent's, so on any load that
// mounts a page and the shell in one commit — a reload, a shared link, a home-screen launch — the
// page has already set its title by the time the shell would have subscribed, and the shell's
// state was read before that. `useSyncExternalStore` re-reads the snapshot after it subscribes.
//
// Not in `pageMeta.ts`, whose header promises it imports nothing at all.

import { useSyncExternalStore } from 'react'
import { readPageMeta, watchPageMeta, type PageMeta } from './pageMeta'

/** Nothing has said anything on a server, where there is no page mounted. */
function nothingSaid(): PageMeta | undefined {
  return undefined
}

/** What the mounted page calls itself, or nothing when it has not said. */
export function usePageMeta(): PageMeta | undefined {
  return useSyncExternalStore(watchPageMeta, readPageMeta, nothingSaid)
}
